/**
 * Cloud provider types for GizmoData Nexus
 */
import type { TLSMode } from './cluster';

export interface Cloud {
  id: string;
  name: string;
  label: string;
  description?: string;
  /**
   * tls_modes a cluster may use on this cloud. 'nlb' means a dedicated L4
   * load balancer — AWS: NLB with ACM-terminated TLS; GCP: passthrough
   * Network LB with pod-terminated TLS. Azure's L4 LB can't terminate TLS,
   * so it omits 'nlb'. The API rejects unsupported modes at create-time;
   * the wizard hides them up front.
   */
  supportedTlsModes: TLSMode[];
  /** tls_mode applied when a create request omits it: AWS/GCP='nlb', Azure='ingress'. */
  defaultTlsMode: TLSMode;
  /** What a cluster with its own load balancer ('nlb') adds to its hourly price on this cloud, in USD;
   *  null where it isn't priced (customer-hosted deployments). */
  dedicatedEndpointPricePerHour?: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface CloudRegion {
  id: string;
  name: string;
  label: string;
  description?: string;
  cloudId: string;
  cloud?: Cloud;
  createdAt: string;
  updatedAt: string;
}

// Regions coming soon (for display purposes)
export const COMING_SOON_REGIONS = [
  // Azure regions
  { cloud: 'Azure', region: 'West US 2', label: 'azure-westus2' },
  { cloud: 'Azure', region: 'West Europe', label: 'azure-westeurope' },
  { cloud: 'Azure', region: 'North Europe', label: 'azure-northeurope' },
  { cloud: 'Azure', region: 'Southeast Asia', label: 'azure-southeastasia' },
  // AWS regions
  { cloud: 'AWS', region: 'US East (N. Virginia)', label: 'aws-us-east-1' },
  { cloud: 'AWS', region: 'US West (Oregon)', label: 'aws-us-west-2' },
  { cloud: 'AWS', region: 'EU (Ireland)', label: 'aws-eu-west-1' },
  { cloud: 'AWS', region: 'EU (Frankfurt)', label: 'aws-eu-central-1' },
  { cloud: 'AWS', region: 'Asia Pacific (Singapore)', label: 'aws-ap-southeast-1' },
  // GCP regions (us-west1 is live — served from the API's cloud-regions list)
  { cloud: 'GCP', region: 'us-east1 (South Carolina)', label: 'gcp-us-east1' },
  { cloud: 'GCP', region: 'europe-west1 (Belgium)', label: 'gcp-europe-west1' },
  { cloud: 'GCP', region: 'asia-southeast1 (Singapore)', label: 'gcp-asia-southeast1' },
];
